import { func, number, oneOfType, string } from "prop-types";

import RadioButton from "@shared/v2/RadioButton";
import FieldLabel from "@shared/v2/FieldLabel";
import { bodyS } from "@shared/styles";

const PriorityRadio = ({ value, setValue }) => (
  <div>
    <FieldLabel className="tw-mb-8px" label="Priority" isRequired />
    <div className="tw-flex tw-justify-between">
      {Array.from({ length: 9 }, (_, index) => index + 1).map((n) => (
        <RadioButton
          value={n}
          label={`${n}`}
          className="tw-cursor-pointer"
          checked={value === n}
          onClick={() => setValue(n)}
        />
      ))}
    </div>
    <div className="tw-flex tw-justify-between tw-mt-4px">
      <span className={bodyS}>Highest</span>
      <span className={bodyS}>Lowest</span>
    </div>
  </div>
);

export default PriorityRadio;

PriorityRadio.propTypes = {
  value: oneOfType([string, number]).isRequired,
  setValue: func.isRequired,
};
